module.exports = __webpack_public_path__ + "static/grandmaster-flash-poster-136b15e997c51b55f4261ec8fa76ec91.jpg";